import { Routes, Route, Navigate } from "react-router-dom";
import Layout from "./components/Layout";
import { ToastProvider } from "./components/Toast";
import { AuthProvider, useAuth } from "./contexts/AuthContext";
import { ThemeProvider } from "./contexts/ThemeContext";
import ProtectedRoute from "./components/ProtectedRoute";
import LoginPage from "./pages/LoginPage";
import AppsPage from "./pages/AppsPage";
import AppDetailPage from "./pages/AppDetailPage";
import NewAppPage from "./pages/NewAppPage";
import EditAppPage from "./pages/EditAppPage";
import UsersPage from "./pages/UsersPage";
import AuditPage from "./pages/AuditPage";
import AuditDetailPage from "./pages/AuditDetailPage";
import NotFoundPage from "./pages/NotFoundPage";

function AppRoutes() {
  const { user } = useAuth();
  const initialTheme = user?.preferences?.theme || "system";

  return (
    <ThemeProvider initialTheme={initialTheme}>
      <Routes>
        {/* Public routes */}
        <Route path="/login" element={<LoginPage />} />

        {/* Protected routes */}
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <Layout />
            </ProtectedRoute>
          }
        >
          <Route index element={<Navigate to="/apps" replace />} />
          <Route path="apps" element={<AppsPage />} />
          <Route path="apps/new" element={<NewAppPage />} />
          <Route path="apps/:id" element={<AppDetailPage />} />
          <Route path="apps/:id/edit" element={<EditAppPage />} />
          <Route path="users" element={<UsersPage />} />
          <Route path="audit" element={<AuditPage />} />
          <Route path="audit/:id" element={<AuditDetailPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Route>
      </Routes>
    </ThemeProvider>
  );
}

function App() {
  return (
    <AuthProvider>
      <ToastProvider>
        <AppRoutes />
      </ToastProvider>
    </AuthProvider>
  );
}

export default App;
